var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent"},[_c('ReactSiteFrame',{attrs:{"id":"site","src":_vm.src,"keepSidebar":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }